import React from 'react';
import { useNavigate } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';

import PAGES from '../pageTree';

import { useAppSelector } from 'src/app/hooks';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import UsuariaAvatar from './UsuariaAvatar';
import { Typography } from '@mui/material';
import { Layout } from 'src/styles';

export default function ProfileMenu() {
  const { key, perfil } = useAppSelector((state) => state.page);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  if (!perfil) {
    return null;
  }

  return (
    <>
      <Tooltip title="Seu perfil">
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          size="small"
          aria-controls={anchorEl ? 'perfil-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={anchorEl ? 'true' : undefined}
          onClick={handleClickUserMenu}
          sx={{ ml: 2 }}>
          <UsuariaAvatar perfil_foto={perfil.foto} size={40} />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="perfil-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: Layout.IconMenu,
          },
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
        <MenuItem color="inherit">
          <Typography variant="overline" color="CaptionText">
            {perfil.label}
          </Typography>
        </MenuItem>
        <MenuItem
          {...(PAGES.perfil.externalUrl
            ? {
                href:
                  typeof PAGES.perfil.externalUrl === 'string'
                    ? PAGES.perfil.externalUrl
                    : PAGES.perfil.externalUrl(false),
              }
            : {})}
          {...(PAGES.perfil.externalUrl ? { target: '_blank' } : {})}
          color="inherit"
          disabled={key === 'perfil'}
          onClick={() => {
            handleClose();
            if (PAGES.perfil.onClick) {
              PAGES.perfil.onClick();
              return;
            }

            if (!PAGES.perfil.externalUrl) {
              navigate('perfil');
            }
          }}>
          {PAGES.perfil.title}
        </MenuItem>
        <MenuItem
          {...(PAGES.signout.externalUrl
            ? {
                href:
                  typeof PAGES.signout.externalUrl === 'string'
                    ? PAGES.signout.externalUrl
                    : PAGES.signout.externalUrl(false),
              }
            : {})}
          {...(PAGES.signout.externalUrl ? { target: '_blank' } : {})}
          color="inherit"
          disabled={key === 'signout'}
          onClick={() => {
            handleClose();
            if (PAGES.signout.onClick) {
              PAGES.signout.onClick();
              return;
            }

            if (!PAGES.signout.externalUrl) {
              navigate('signout');
            }
          }}>
          {PAGES.signout.title}
        </MenuItem>
      </Menu>
    </>
  );
}
